var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWxTropical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.44 103.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    fill: "orange"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.43,61A42.67,42.67,0,0,1,77.89,90.1c-3,3.24-8.21-.39-6.26-4.35a29,29,0,0,0,2.69-8.1.91.91,0,0,0-1.55-.75,40.88,40.88,0,0,1-28,11.69C25,88.59-.51,72.91,0,42.69a42.68,42.68,0,0,1,11.54-29.1c3-3.24,8.21.39,6.26,4.35A28.59,28.59,0,0,0,15.13,26a.9.9,0,0,0,1.54.76A40.85,40.85,0,0,1,44.72,15.1C64.48,15.1,90,30.78,89.43,61ZM23.87,10.49a24.24,24.24,0,0,1,5.17-4,17.87,17.87,0,0,1,6.05-2.17h.06A2.08,2.08,0,0,0,34.84.22a22.73,22.73,0,0,0-8,1.54,30.11,30.11,0,0,0-7.09,3.86l0,0q-.18.13-.36.3a3.19,3.19,0,0,0,4.5,4.53ZM47.35,4.32h0a1.35,1.35,0,0,0,.81-2.57A28.92,28.92,0,0,0,42.76.05h0a1.47,1.47,0,0,0-.36,0,1.89,1.89,0,0,0,0,3.78A25.89,25.89,0,0,1,47.35,4.32ZM65.57,93.21a24.27,24.27,0,0,1-5.17,4,18.11,18.11,0,0,1-6,2.18h-.06a2.07,2.07,0,0,0,.32,4.12,22.9,22.9,0,0,0,8-1.53,30.51,30.51,0,0,0,7.09-3.87l0,0a3.65,3.65,0,0,0,.36-.31,3.19,3.19,0,1,0-4.5-4.52ZM42.09,99.37h0a1.35,1.35,0,0,0-.81,2.57,29.6,29.6,0,0,0,5.41,1.71h0a1.47,1.47,0,0,0,.36,0,1.89,1.89,0,1,0,0-3.78A25.89,25.89,0,0,1,42.09,99.37ZM26.69,33.82a25.49,25.49,0,1,0,36.06,0A25.48,25.48,0,0,0,26.69,33.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.72,
    cy: 51.85,
    r: 13.44
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxTropical);
export default __webpack_public_path__ + "static/media/wxTropical.4f74cbe07585c52d2a50331015e31e5d.svg";
export { ForwardRef as ReactComponent };